module.exports = __webpack_public_path__ + "static/FY_2022_Investor_call_Dial-in_information-681cd90e2cf1e17905c33e0aff9b71fa.pdf";